/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import SelectionOfDeveloperManagement from './SelectionOfDeveloperManagement';
import TableOfDeveloperManagement from './TableOfDeveloperManagement';
import Typography from '@material-ui/core/Typography';
import store from "../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
class DeveloperManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "开发商管理";
  }
  componentWillUnmount() { }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          开发商管理
        </Typography>
        <SelectionOfDeveloperManagement />
        <TableOfDeveloperManagement />
      </div>
    );
  }
}

const DeveloperManagement = observer(DeveloperManagementInner);

DeveloperManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DeveloperManagement);
